import React from 'react'

// SellerPresence — Phase G
//
// Compact "🟢 Online" / "⚪ 5 dəqiqə əvvəl aktiv idi" badge.
//
// Props:
//   isOnline:   boolean
//   statusText: pre-formatted Azerbaijani string from useSellerPresence
//   size:       'sm' | 'md'  (default sm)
//   className:  optional extra classes

const SIZE = {
    sm: { dot: 'h-2 w-2',  text: 'text-[11px]' },
    md: { dot: 'h-2.5 w-2.5', text: 'text-xs'   },
}

const SellerPresence = ({
    isOnline = false,
    statusText = 'Son aktivlik məlum deyil',
    size = 'sm',
    className = '',
}) => {
    const cfg = SIZE[size] || SIZE.sm
    return (
        <span className={`inline-flex items-center gap-1.5 ${cfg.text} ${className}`}>
            <span
                aria-hidden='true'
                className={`inline-flex shrink-0 rounded-pill ${cfg.dot} ${
                    isOnline
                        ? 'bg-success-500 ring-2 ring-success-200/60'
                        : 'bg-slate-300'
                }`}
            />
            <span className={`truncate ${isOnline ? 'font-semibold text-success-700' : 'text-slate-500'}`}>
                {isOnline ? 'Online' : statusText}
            </span>
        </span>
    )
}

export default SellerPresence
